/* Component Dependencies */
var drivingDirectionsTemplate = require('templates/drivingDirections.hbs');
var AriesComponent = require('libs/aries-component');
var googleApiWrapper = require('js-google-api-wrapper');
var AutoComplete = require('libs/autocomplete');
var Popup = require('libs/popup');
var $ = require('jquery');

AriesComponent.create({
  type: 'drivingDirections',
  template: {
    'drivingDirections': drivingDirectionsTemplate
  },
  subscribe: {
    'SHOW_DIRECTION_SEARCH_ERROR': 'showDirectionSearchError'
  },
  events: {
    'click .js-form-submit': 'showDirectionsModal',
    'click .js-clear-error-btn': 'clearSearchError',
    'click .js-reset-control-state': 'resetControlState'
  },
  bindEvents: function() {
    var _self = this;
    _self.tileData = _self.$el.find(".data-tile");
    if (_self.tileData.data('displayTile')) {
      _self.$searchControlElm = this.$el.find('#search-control');
      _self.$listContainerElm = _self.$el.find('.l-search-control-group');
      _self.$directionsOption = _self.$el.find('.data-direction-option');
      _self.$clearErrorBtn = _self.$el.find('.js-clear-error-btn');
      _self.$addressErrorElm = _self.$el.find('.l-address-not-found');
      _self.$drivingErrorElm = _self.$el.find('.l-driving-details-not-found');
      _self.loadMapsApi();
      _self.setDefaultChecked();
      _self.registerModal();
    }
  },
  /**
   * Load Google API and initiate AutoComplete component on success callback
   * @return {void}
   */
  loadMapsApi: function() {
    var _self = this;
    googleApiWrapper.loadApi(_self.tileData.data('googleMapApiUrl'))
      .then(function(apiWrapper) {
        _self.mapsApiWrapper = apiWrapper;
        _self.initAutoComplete();
      });
  },
  /**
   * Bind AutoComplete component to search input element.
   * @return {void}
   */
  initAutoComplete: function() {
    var _self = this;
    _self.autoCompleteOptions = {
      disableRecentSearch: true,
      disableCurrentLocSearch: true,
      searchLabel: _self.tileData.data('searchResults'),
      onSearch: _self.autoCompleteSearch.bind(_self),
      onSelect: _self.autoCompleteSelected.bind(_self),
      listContainerEl: _self.$listContainerElm
    };
    _self.autoCompleteComponent = new AutoComplete(_self, _self.$searchControlElm[0], _self.autoCompleteOptions);
    _self.autocompleteService = _self.mapsApiWrapper.getAutocompleteService();
  },
  /**
   * Search callback for auto complete component
   * @param {string} searchTerm - Search term
   * @returns {Object} - Promise object to be resolved/rejected with API response
   */
  autoCompleteSearch: function(searchTerm) {
    var _self = this;
    _self.resetControlState();
    return new Promise(function(resolve, reject) {
      _self.autocompleteService.searchPlaces({ input: searchTerm })
        .then(function(predictions) {
          resolve({
            searchTerm: searchTerm,
            searchResult: _self.parseAutoCompletePredictions(predictions)
          });
        }, function(err) {
          reject(err);
        });
    });
  },
  /**
   * Select suggestion callback for auto complete component
   * @param {string} type - Type of suggestion item selected (location, recent or prediction)
   * @param {HTMLElement} el - Selected suggestion list item
   * @param {Object} data - Data associated with selected suggestion listitem
   */
  autoCompleteSelected: function(type, el, data) {
    if (data) {
      $(el).addClass('is-place-selected').attr('data-location-address', data.locationAddress);
      $(el).attr('data-place-id', data.placeId);
    }
  },
  /**
   * Parse search results predictions
   * @param {Array} predictions - Google Api predictions list
   * @return {Array} - Formatted data to show into autocomplete list
   */
  parseAutoCompletePredictions: function(predictions) {
    var predictionList = [];
    predictions.forEach(function(prediction) {
      if (prediction.types.indexOf('colloquial_area') === -1) {
        predictionList.push({
          mainText: prediction.structured_formatting.main_text,
          secondaryText: prediction.structured_formatting.secondary_text || '',
          locationAddress: prediction.description,
          placeId: prediction.place_id
        });
      }
    });
    return predictionList;
  },
  /**
   * Clear search input control, error state and associated error message
   * on click of clear error button
   * @param {Object} event object is passed
   * @return {void}
   */
  clearSearchError: function(event) {
    var _self = this;
    _self.$searchControlElm.val('');
    _self.resetControlState();
  },
  /**
   * Reset error state and hide error message
   * @return {void}
   */
  resetControlState: function() {
    var _self = this;
    if (_self.$searchControlElm.hasClass('is-error')) {
      _self.$searchControlElm.removeClass('is-error');
      _self.$clearErrorBtn.toggleClass('l-display-none l-display-inline-block');
      // clearing error elements
        _self.$addressErrorElm.removeClass('l-display-block');
        _self.$addressErrorElm.addClass('l-display-none');
        _self.$drivingErrorElm.removeClass('l-display-block');
        _self.$drivingErrorElm.addClass('l-display-none');
    }
  },
  /**
   * Trigger driving details modal with selected location
   * @param {Object} event object is passed
   * @return {void}
   */
  showDirectionsModal: function(event) {
    var _self = this,
      placeSelectedElm, locationAddress, queryParams,
      $autoCompleteList = _self.$el.find('.autocomplete-list>.autocomplete-listitem'), latitude, longitude;
    event.preventDefault();
    event.stopPropagation();
    _self.resetControlState();
    if (_self.$searchControlElm.val().trim()) {
      if ($autoCompleteList.length) {
        placeSelectedElm = $autoCompleteList.filter('.is-place-selected');
        if (placeSelectedElm.length) {
          locationAddress = placeSelectedElm.attr('data-location-address');
          if(_self.$el.hasClass('js-baidu-map'))
          googlePlaceId = placeSelectedElm.attr('data-place-id');
        } else {
          locationAddress = _self.autoCompleteComponent.getDataByListItem($autoCompleteList.eq(0)[0]).locationAddress;
          if(_self.$el.hasClass('js-baidu-map'))
          googlePlaceId = _self.autoCompleteComponent.getDataByListItem($autoCompleteList.eq(0)[0]).placeId;
        }
        if(_self.$el.hasClass('js-baidu-map')) {
          var geocoder = new google.maps.Geocoder();
          geocoder.geocode({
            'placeId': googlePlaceId
          }, function (results, status) {
            if (status == 'OK') {
              latitude = results[0].geometry.location.lat();
              longitude = results[0].geometry.location.lng();
            }
            queryParams = '?locationAddress=' + encodeURIComponent(locationAddress) +
            '&isStartWayPointHotel=' + _self.$directionsOption.find('input:checked').val() +
            '&marshaCode=' + _self.tileData.data('marshaCode') + '&latitude=' + latitude + '&longitude=' + longitude;
            if (!_self.isPopupRegistered) {
              _self.drivingDetailsPopup.url = _self.tileData.data('directionsResultsUrl') + queryParams;
              _self.drivingDetailsPopup.register();
              _self.isPopupRegistered = true;
            } else {
              _self.drivingDetailsPopup.popupOptions.items.src = _self.tileData.data('directionsResultsUrl') + queryParams;
              _self.drivingDetailsPopup.openPopup();
            }
          });
        } else {
          queryParams = '?locationAddress=' + encodeURIComponent(locationAddress) +
          '&isStartWayPointHotel=' + _self.$directionsOption.find('input:checked').val() +
          '&marshaCode=' + _self.tileData.data('marshaCode');
          if (!_self.isPopupRegistered) {
            _self.drivingDetailsPopup.url = _self.tileData.data('directionsResultsUrl') + queryParams;
            _self.drivingDetailsPopup.register();
            _self.isPopupRegistered = true;
          } else {
            _self.drivingDetailsPopup.popupOptions.items.src = _self.tileData.data('directionsResultsUrl') + queryParams;
            _self.drivingDetailsPopup.openPopup();
          }
        };
      } else {
        _self.showDirectionSearchError();
      }
    }
  },
  /**
   * Set default driving direction option
   * @return {void}
   */
  setDefaultChecked: function() {
    var _self = this;
    _self.$directionsOption.find('input[data-option=' + _self.$directionsOption.data('default-checked') + ']')
      .prop('checked', true);
  },
  /**
   * Register driving details popup
   * @return {void}
   */
  registerModal: function() {
    var _self = this;
    _self.drivingDetailsPopup = new Popup({
      sourceBlock: '.modal-content',
      showPrintButton: true,
      open: true,
      addClassOnmfpWrap: true,
      mfpWrapClassName: 'l-map-print'
    });
  },
  /**
   * Show error when there is no route.
   * @return {void}
   */
  showDirectionSearchError: function(data) {
    var _self = this;
    if (data) {
      var directionStatusCode = data.status;
      // "car less route" / "travel method not supported" error
      if (directionStatusCode === 7 || directionStatusCode === 3001) {
        _self.$searchControlElm.addClass('is-error');
        _self.$clearErrorBtn.toggleClass('l-display-inline-block l-display-none');
        _self.$drivingErrorElm.toggleClass('l-display-block l-display-none');
      } 
    }
    else {
      // invalid address error
      _self.$searchControlElm.addClass('is-error');
      _self.$clearErrorBtn.toggleClass('l-display-inline-block l-display-none');
      _self.$addressErrorElm.toggleClass('l-display-block l-display-none');
    }
  }
});
